import {useApi} from "@contexts/hooks/api/useApi.ts";
import {__formapagto_endpoints} from "@components/formaPagamento/endpoints/__formapagto_endpoints.ts";
import {IGetFormaPagtoFilter} from "@components/formaPagamento/models/GetFormaPagtoFilter.ts";
import {IDataDto} from "@models/shared/IDataDto.ts";
import {IFormaPagamento} from "@models/formaPagamento/IFormaPagamento.ts";
import {useValue} from "@components/shared/hooks/useValue.tsx";


export function useFormaPagamento() {
    const {Get} = useApi()


    const getFormasPagamentoById = (data: { id: number }) => {
        return Get(__formapagto_endpoints.v2["get-forma-pagto"](data))
    }
    const getFormasPagamento = (data: IDataDto<IGetFormaPagtoFilter>) => {
        return Get(__formapagto_endpoints.v2["get-formas-pagto"](data))
    }

    const getForms = (data: IDataDto<{ formaPagtoId: number }>) => {
        return Get(__formapagto_endpoints.v2.forms["get-forms"](data))
    }
    const createFormsFormaPagto = (data: { formaPagtoId: number, forms: { nome: string, descricao?: string }[] }) => {
        return Get(__formapagto_endpoints.v2.forms["create-forms"]({
            data: {
                formaPagtoId: data.formaPagtoId,
                forms: data.forms,
            }
        }))
    }


    return {
        useFormaPagamentoValue: (p: IFormaPagamento | number) => useValue({
            value: p,
            getter: () => getFormasPagamentoById({id: typeof p === 'number' ? p : p.id})
        }),
        getFormasPagamentoById: getFormasPagamentoById,
        getFormasPagamento: getFormasPagamento,
        getForms: getForms,
        createFormsFormaPagto: createFormsFormaPagto,
    }
}